import api from "./api"
import { getStoredShipper } from "../constants/utils"

const switchRequestApi = {
    getSwitchInstructionPatterns() {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()
        return api.post("rvp/api/ListSwitchInstructionPatterns", {
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
        })
    },
    createSwitchInstruction(InstructionDetails = {}) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()
        return api.post("rvp/api/CreateSwitchInstruction", {
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
            InstructionDetails: InstructionDetails,
        })
    },
    getAllSwitchRequestsData({ filter }) {
        const { STORED_SHIPPER_NAME, STORED_RAILROAD_NAME } = getStoredShipper()

        return api.post("/rvp/api/ListSwitchInstructions", {
            ApiStandardParameters: {
                Road: STORED_RAILROAD_NAME,
                Shipper: STORED_SHIPPER_NAME,
            },
            Filter: filter,
        })
    },
}

export default switchRequestApi
